let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("054RK")).then(() => parcelRequire('ei7L7'));